'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.daysDiff = daysDiff;
exports.daysOnlyDiff = daysOnlyDiff;
exports.daysUntilNow = daysUntilNow;
exports.formatDate = formatDate;
exports.getFormattedTime = getFormattedTime;
exports.getMeetingDate = void 0;
exports.hoursDiff = hoursDiff;
exports.hoursUntilNow = hoursUntilNow;
exports.isPastDate = void 0;
exports.minutesDiff = minutesDiff;
exports.minutesUntilNow = minutesUntilNow;
exports.relativeDate = relativeDate;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var MS_PER_DAY = 86400000;
var MS_PER_HOUR = 3600000;
var MS_PER_MINUTE = 60000;
var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var maxHours = 12;
var decimalCount = 10;
var shortLength = 3;
var NO_DAY = 0;
var ONE_DAY = 1;
var SEVEN_DAYS = 7;
var translations = {
  today: (0, _jsx2.default)(_reactIntl.FormattedMessage, {
    id: "today"
  }),
  yesterday: (0, _jsx2.default)(_reactIntl.FormattedMessage, {
    id: "yesterday"
  })
};
function utcDateDiff(a, b) {
  var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate(), a.getHours(), a.getMinutes());
  var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate(), b.getHours(), b.getMinutes());
  return Math.abs(utc2 - utc1);
}
function utcDaysDiff(a, b) {
  var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
  return Math.abs(utc2 - utc1);
}
function daysDiff(a, b) {
  return Math.floor(utcDateDiff(a, b) / MS_PER_DAY);
}
function daysOnlyDiff(a, b) {
  return Math.floor(utcDaysDiff(a, b) / MS_PER_DAY);
}
function hoursDiff(a, b) {
  return Math.floor(utcDateDiff(a, b) / MS_PER_HOUR);
}
function minutesDiff(a, b) {
  return Math.floor(utcDateDiff(a, b) / MS_PER_MINUTE);
}
function daysUntilNow(date) {
  var isDaysOnlyDiff = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return isDaysOnlyDiff ? daysOnlyDiff(new Date(), new Date(date)) : daysDiff(new Date(), new Date(date));
}
function hoursUntilNow(date) {
  return hoursDiff(new Date(), new Date(date));
}
function minutesUntilNow(date) {
  return minutesDiff(new Date(), new Date(date));
}
function formatDate(dateObj, format) {
  var formattedDate = '';
  if (!!dateObj === false || dateObj == 'Invalid Date') {
    return formattedDate;
  }
  var date = dateObj.getDate();
  var month = dateObj.getMonth();
  var year = dateObj.getFullYear();
  var monthNum = month + 1;
  var DD = date >= decimalCount ? date : "0".concat(date);
  var MM = monthNum >= decimalCount ? monthNum : "0".concat(monthNum);
  switch (format) {
    case 'DD/MM/YY':
      {
        var mm = monthNum >= decimalCount ? monthNum : "0".concat(monthNum);
        var yy = String(year).substr(2);
        formattedDate = "".concat(date, "/").concat(mm, "/").concat(yy);
        break;
      }
    case 'YYYY-MM-DD':
      {
        formattedDate = "".concat(year, "-").concat(MM, "-").concat(DD);
        break;
      }
    case 'Day, DD Month':
      {
        formattedDate = "".concat(dayNames[dateObj.getDay()], ", ").concat(date, " ").concat(monthNames[month]);
        break;
      }
    case 'DD':
      {
        formattedDate = "".concat(date);
        break;
      }
    case 'Day':
      {
        formattedDate = "".concat(dayNames[dateObj.getDay()]);
        break;
      }
    case 'DD Month':
      {
        formattedDate = "".concat(date, " ").concat(monthNames[month]);
        break;
      }
    case 'DD Month YYYY':
      {
        formattedDate = "".concat(date, " ").concat(monthNames[month], " ").concat(year);
        break;
      }
    case 'DD Mon':
      formattedDate = "".concat(date, " ").concat(monthNames[month].slice(0, shortLength));
      break;
  }
  return formattedDate;
}
function relativeDate(date, dateFormat) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  dateFormat = dateFormat || {
    month: 'short',
    day: '2-digit'
  };
  var today = new Date();
  var currentDate = new Date(date);
  var diff = daysDiff(currentDate, today);
  if (diff > ONE_DAY && diff < SEVEN_DAYS) {
    return (0, _jsx2.default)(_reactIntl.FormattedRelative, {
      value: currentDate,
      style: "numeric"
    }, void 0, function (date) {
      return /*#__PURE__*/_react.default.createElement("span", props, date);
    });
  }
  switch (diff) {
    case NO_DAY:
      return translations.today;
    case ONE_DAY:
      return translations.yesterday;
    default:
      return /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, (0, _extends2.default)({
        value: currentDate
      }, dateFormat), function (date) {
        return /*#__PURE__*/_react.default.createElement("span", props, date);
      });
  }
}
function getFormattedTime(timeString) {
  var hideZeroes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var hourEnd = timeString.indexOf(':');
  var H = Number(timeString.substr(0, hourEnd));
  var M = Number(timeString.substr(hourEnd + 1, hourEnd.length));
  var h = H % maxHours || maxHours;
  var ampm = H < maxHours || H === maxHours * 2 ? ' AM' : ' PM';
  timeString = h + (M === 0 && hideZeroes ? '' : timeString.substr(hourEnd, shortLength)) + ampm;
  return timeString;
}
var getMeetingDate = exports.getMeetingDate = function getMeetingDate(date, lang) {
  var year = date === null || date === void 0 ? void 0 : date.split('-')[0];
  var month = date && parseInt(date === null || date === void 0 ? void 0 : date.split('-')[1], 10) - 1;
  var day = date === null || date === void 0 ? void 0 : date.split('-')[2];
  var meetingDateObj = new Date();
  if (date) {
    meetingDateObj.setFullYear(year, month, day);
  }
  var meetingDate = meetingDateObj.toLocaleDateString(lang, {
    day: 'numeric'
  });
  var meetingMonth = meetingDateObj.toLocaleDateString(lang, {
    month: 'short'
  });
  var meetingYear = meetingDateObj.toLocaleDateString(lang, {
    year: 'numeric'
  });
  var meetingWeekday = meetingDateObj.toLocaleDateString(lang, {
    weekday: 'short'
  });
  meetingMonth = "".concat(meetingMonth.charAt(0).toUpperCase()).concat(meetingMonth.slice(1));
  meetingWeekday = "".concat(meetingWeekday.charAt(0).toUpperCase()).concat(meetingWeekday.slice(1));
  var dateString = date && "".concat(meetingWeekday, ", ").concat(meetingDate, " ").concat(meetingMonth, " ").concat(meetingYear);
  var daysLeft = date && daysUntilNow(date, true);
  return {
    dateString: dateString,
    meetingDate: meetingDate,
    meetingMonth: meetingMonth,
    meetingWeekday: meetingWeekday,
    daysLeft: daysLeft
  };
};

/**
 *
 * @param {string(format YYYY-MM-DD)} dateString
 * @returns { boolean }
 */
var isPastDate = exports.isPastDate = function isPastDate(dateString) {
  var now = new Date();
  return new Date(dateString).setHours(0, 0, 0, 0) < now.setHours(0, 0, 0, 0);
};